

import Component from 'generic.basecomponent';
import TweenLite from 'gsap/TweenLite';
import menuManager from 'menu-manager';
import { MOBILE_MENU_ID } from '../../hamburger/js/generic.hamburger';
import app from '../../../general/js/app-instance';

export default class SearchTop extends Component {
    constructor(el) {
        super(el);
        this.init();
    }

    init() {
        this.defineVariables();
        this.toggle.addEventListener('click', this.toggleMenu.bind(this));
        this.shadow.addEventListener('click', this.toggleMenu.bind(this));
        if (this.trigger) {
            this.trigger.addEventListener('click', this.searchTrigger.bind(this));
            this.trigger.classList.add('js-search-top-trigger-inited');
        }
    }

    defineVariables() {
        this.menuId = 'search';
        this.isOpened = false;
        this.toggle = this.container.querySelector('.js-toggle');
        this.content = this.container.querySelector('.js-content');
        this.input = this.container.querySelector('.js-search-box');
        this.shadow = document.querySelector('.nav-top__shadow-bg');
        this.trigger = document.querySelector('.js-search-top-trigger:not(.js-search-top-trigger-inited)');

        const elementsToHide = [
            document.querySelector('.navbar'),
            document.querySelectorAll('.header__nav-btn')[0],
            document.querySelectorAll('.header__nav-btn')[1],
            document.querySelector('.js-search-top-mobile')
        ];

        this.elementsToHide = elementsToHide.reduce((result, el) => {
            if (el) {
                result.push(el);
            }
            return result;
        }, []);

        this.headerNav = document.querySelector('.header__nav');
        this.body = document.body;
    }

    toggleMenu(e) {
        if (e) e.preventDefault();

        if (!this.isOpened) {
            this.openDesktop();
        } else {
            this.closeDesktop();
        }
    }


    openDesktop() {
        this.isOpened = true;
        TweenLite.from(this.content, 0.3, { y: -300 });
        TweenLite.to(this.content, 0.3, {
            y: 0,
            onComplete: () => {
                this.input.focus();
            }
        });
        this.container.classList.add('is-opened');
        this.toggle.querySelector('svg.icon use').setAttribute('xlink:href', '#icon-modal_close');

        this.elementsToHideDisplay = this.elementsToHide.map((element) => {
            const display = element.style.display;
            element.style.display = 'none';
            return display;
        });

        this.shadow.classList.add('is-visible');
    }


    closeDesktop() {
        this.isOpened = false;
        TweenLite.from(this.content, 0.3, { y: 0 });
        const self = this;
        TweenLite.to(this.content, 0.3, {
            y: -300,
            onComplete() {
                self.container.classList.remove('is-opened');
            }
        });
        this.toggle.querySelector('svg.icon use').setAttribute('xlink:href', '#icon-search');

        this.elementsToHide.forEach((element, index) => {
            element.style.display = this.elementsToHideDisplay[index];
        });

        this.shadow.classList.remove('is-visible');
    }

    searchTrigger(e) {
        e.preventDefault();
        window.scrollTo(0, 0);
        if (app.isDesktop) {
            this.openDesktop();
        } else {
            menuManager.open(MOBILE_MENU_ID);
        }
    }
}

SearchTop.id = 0;



// WEBPACK FOOTER //
// ./app/components/search-top/js/generic.search-top.js